import Service from "./Service";
const baseurl = '/api/educacion';

export default {
    showByCodigo(codigo) {
        return Service.get(`${baseurl}/show-by-codigo/${codigo}`);
    }
}
